var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "#BBC2D3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9942 5.14688L1.36883 0.52304C1.16587 0.320594 0.837042 0.320594 0.633571 0.52304C0.430613 0.725485 0.430613 1.05431 0.633571 1.25676L4.89207 5.51372L0.634083 9.77067C0.431125 9.97312 0.431125 10.3019 0.634083 10.5049C0.837042 10.7073 1.16638 10.7073 1.36934 10.5049L5.99472 5.88111C6.19456 5.68076 6.19456 5.34676 5.9942 5.14688Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNext);
export default __webpack_public_path__ + "static/media/icon-next.35be49710b5728d081083f0b0d437916.svg";
export { ForwardRef as ReactComponent };